import { KeyValueDefault } from "@/main/models/common";

export enum IntegrationTriggerTypes {
	GET_INTEGRATION_TRIGGER = "@integrationTrigger/GET_INTEGRATION_TRIGGER",
	SAVE_INTEGRATION_TRIGGER = "@integrationTrigger/SAVE_INTEGRATION_TRIGGER",
	RESET_INTEGRATION_TRIGGER = "@integrationTrigger/RESET_INTEGRATION_TRIGGER",
}

export interface IntegrationTriggerState {
	readonly integrationTriggers: {
		data: KeyValueDefault[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetIntegrationTriggers {
	type: typeof IntegrationTriggerTypes.GET_INTEGRATION_TRIGGER;
}

export interface SaveIntegrationTriggers {
	type: typeof IntegrationTriggerTypes.SAVE_INTEGRATION_TRIGGER;
	payload: {
		data: KeyValueDefault[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerIntegrationTriggers {
	type: typeof IntegrationTriggerTypes.RESET_INTEGRATION_TRIGGER;
}

export type IntegrationTriggerActionTypes =
	| GetIntegrationTriggers
	| SaveIntegrationTriggers
	| ResetReducerIntegrationTriggers;
